import { useState } from "react";

function formatearMonto(v) {
  const n = Number(v);
  if (!isFinite(n)) return "0.00";
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Input de monto con separador de miles (0,000.00). Muestra el valor formateado
 * cuando no tiene foco; al enfocarlo muestra el número crudo para editar sin
 * que el cursor salte por las comas.
 */
export function MoneyInput({ value, onChange, style }) {
  const [focused, setFocused] = useState(false);

  return (
    <input
      type="text"
      inputMode="decimal"
      value={focused ? value : formatearMonto(value)}
      onFocus={(e) => { setFocused(true); e.target.select(); }}
      onBlur={() => setFocused(false)}
      onChange={(e) => {
        const raw = e.target.value.replace(/[^0-9.-]/g, "");
        onChange(raw);
      }}
      style={style}
    />
  );
}
